import { render, staticRenderFns } from "./PetStorePage.vue?vue&type=template&id=c3dc8448&scoped=true"
import script from "./PetStorePage.vue?vue&type=script&lang=js"
export * from "./PetStorePage.vue?vue&type=script&lang=js"
import style0 from "./PetStorePage.vue?vue&type=style&index=0&id=c3dc8448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dc8448",
  null
  
)

export default component.exports